import { GetFieldPathValueMap as GetW9FieldPathValueMap, GetWellFormedAddress as GetW9WellFormedAddress } from 'common/Addresses/AddressFormatters/W9AddressFormatter';
import { GetFieldPathValueMap as GetW8BenEFieldPathValueMap, GetWellFormedAddress as GetW8BenEWellFormedAddress } from 'common/Addresses/AddressFormatters/W8BenEAddressFormatter';
import { GetFieldPathValueMap as GetW8ExpFieldPathValueMap, GetWellFormedAddress as GetW8ExpWellFormedAddress } from 'common/Addresses/AddressFormatters/W8ExpAddressFormatter';
import { GetFieldPathValueMap as GetW8ImyFieldPathValueMap, GetWellFormedAddress as GetW8ImyWellFormedAddress } from 'common/Addresses/AddressFormatters/W8ImyAddressFormatter';
import { GetFieldPathValueMap as GetW8EciFieldPathValueMap,
  GetW8Eci2014WellFormedAddress,
  GetW8Eci2014FieldPathValueMap,
  GetWellFormedAddress as GetW8EciWellFormedAddress
} from 'common/Addresses/AddressFormatters/W8EciAddressFormatter';
import { GetFieldPathValueMap as GetW8BenFieldPathValueMap, GetWellFormedAddress as GetW8BenWellFormedAddress } from 'common/Addresses/AddressFormatters/W8BenAddressFormatter';
import { GetFieldPathValueMap as GetCrsiFieldPathValueMap, GetWellFormedAddress as GetCrsiWellFormedAddress } from 'common/Addresses/AddressFormatters/CrsiAddressFormatter';
import { GetFieldPathValueMap as GetUCrsiFieldPathValueMap, GetWellFormedAddress as GetUCrsiWellFormedAddress } from 'common/Addresses/AddressFormatters/UCrsiAddressFormatter';
import { GetFieldPathValueMap as GetUCrseFieldPathValueMap, GetWellFormedAddress as GetUCrseWellFormedAddress } from 'common/Addresses/AddressFormatters/UCrseAddressFormatter';
import { GetFieldPathValueMap as GetFatcaCrsiFieldPathValueMap,
  GetWellFormedAddress as GetFatcaCrsiWellFormedAddress } from 'common/Addresses/AddressFormatters/CombinedFormAddressFormatter/CommonCombinedFormAddressFormatter';
import {
  GetFieldPathValueMap as GetFatcaCrseFieldPathValueMap,
  GetWellFormedAddress as GetFatcaCrseWellFormedAddress
} from 'common/Addresses/AddressFormatters/CombinedFormAddressFormatter/FatcaCrseAddressFormatter';

import { GetFieldPathValueMap as GetCrseFieldPathValueMap, GetWellFormedAddress as GetCrseWellFormedAddress } from 'common/Addresses/AddressFormatters/CrseAddressFormatter';
import { GetFieldPathValueMap as GetCrsCpFieldPathValueMap, GetWellFormedAddress as GetCrsCpWellFormedAddress } from 'common/Addresses/AddressFormatters/CrsCpAddressFormatter';
import { GetFieldPathValueMap as GetUCrsCpFieldPathValueMap, GetWellFormedAddress as GetUCrsCpWellFormedAddress } from 'common/Addresses/AddressFormatters/UCrsCpAddressFormatter';
import { GetFieldPathValueMap as GetUCarfCpFieldPathValueMap, GetWellFormedAddress as GetUCarfCpWellFormedAddress } from 'common/Addresses/AddressFormatters/UCarfCpAddressFormatter';
import { GetFieldPathValueMap as GetUCarfiFieldPathValueMap, GetWellFormedAddress as GetUCarfiWellFormedAddress } from 'common/Addresses/AddressFormatters/UCarfiAddressFormatter';
import { GetFieldPathValueMap as GetUCarfeFieldPathValueMap, GetWellFormedAddress as GetUCarfeWellFormedAddress } from 'common/Addresses/AddressFormatters/UCarfeAddressFormatter';

export default function AddressFormatterFactory(formType) {
  switch (formType?.family) {
    case 'w8bene': {
      return {
        GetFieldPathValueMap: GetW8BenEFieldPathValueMap,
        GetWellFormedAddress: GetW8BenEWellFormedAddress
      };
    }
    case 'w9': {
      return {
        GetFieldPathValueMap: GetW9FieldPathValueMap,
        GetWellFormedAddress: GetW9WellFormedAddress
      };
    }
    case 'w8exp': {
      return {
        GetFieldPathValueMap: GetW8ExpFieldPathValueMap,
        GetWellFormedAddress: GetW8ExpWellFormedAddress
      };
    }
    case 'w8imy': {
      return {
        GetFieldPathValueMap: GetW8ImyFieldPathValueMap,
        GetWellFormedAddress: GetW8ImyWellFormedAddress
      };
    }
    case 'w8eci': {
      if (formType?.code === 'w8eci_2014') {
        return {
          GetFieldPathValueMap: GetW8Eci2014FieldPathValueMap,
          GetWellFormedAddress: GetW8Eci2014WellFormedAddress
        };
      }
      return {
        GetFieldPathValueMap: GetW8EciFieldPathValueMap,
        GetWellFormedAddress: GetW8EciWellFormedAddress
      };
    }
    case 'w8ben': {
      return {
        GetFieldPathValueMap: GetW8BenFieldPathValueMap,
        GetWellFormedAddress: GetW8BenWellFormedAddress
      };
    }
    case 'crsi': {
      return {
        GetFieldPathValueMap: GetCrsiFieldPathValueMap,
        GetWellFormedAddress: GetCrsiWellFormedAddress
      };
    }
    case 'ucrsi': {
      return {
        GetFieldPathValueMap: GetUCrsiFieldPathValueMap,
        GetWellFormedAddress: GetUCrsiWellFormedAddress
      };
    }
    case 'fatcacrsi': {
      return {
        GetFieldPathValueMap: GetFatcaCrsiFieldPathValueMap,
        GetWellFormedAddress: GetFatcaCrsiWellFormedAddress
      };
    }
    case 'fatcacrse': {
      return {
        GetFieldPathValueMap: GetFatcaCrseFieldPathValueMap,
        GetWellFormedAddress: GetFatcaCrseWellFormedAddress
      };
    }
    case 'crse': {
      return {
        GetFieldPathValueMap: GetCrseFieldPathValueMap,
        GetWellFormedAddress: GetCrseWellFormedAddress
      };
    }
    case 'ucrse': {
      return {
        GetFieldPathValueMap: GetUCrseFieldPathValueMap,
        GetWellFormedAddress: GetUCrseWellFormedAddress
      };
    }
    case 'crscp': {
      return {
        GetFieldPathValueMap: GetCrsCpFieldPathValueMap,
        GetWellFormedAddress: GetCrsCpWellFormedAddress
      };
    }
    case 'ucrscp': {
      return {
        GetFieldPathValueMap: GetUCrsCpFieldPathValueMap,
        GetWellFormedAddress: GetUCrsCpWellFormedAddress
      };
    }
    case 'ucarfcp': {
      return {
        GetFieldPathValueMap: GetUCarfCpFieldPathValueMap,
        GetWellFormedAddress: GetUCarfCpWellFormedAddress
      };
    }
    case 'ucarfe': {
      return {
        GetFieldPathValueMap: GetUCarfeFieldPathValueMap,
        GetWellFormedAddress: GetUCarfeWellFormedAddress
      };
    }
    case 'ucarfi': {
      return {
        GetFieldPathValueMap: GetUCarfiFieldPathValueMap,
        GetWellFormedAddress: GetUCarfiWellFormedAddress
      };
    }
    default:
      return null;
  }
}
